import React from "react";
import {DatePicker as AntdDatePicker, DatePickerProps} from "antd";
import LocaleProvider from "../../../i18n/LocaleProvider";

type IProps = {
    confirm?: boolean
} & DatePickerProps

class DatePicker extends React.Component<IProps> {

    render() {
        const {onChange, onSelect, confirm} = this.props;

        return <AntdDatePicker locale={LocaleProvider.getPicker()} {...this.props}
                               panelRender={panel => <div className={confirm ? '' : ' ant-picker-no-ok'}>{panel}</div> }
                               onSelect={date => {
                                   onSelect?.(date)
                                   !confirm && onChange?.(date, date.toISOString())
                               }}/>
    }
}

export default DatePicker